export default __webpack_public_path__ + "static/media/4.e31b3251.svg";